import { InteractiveTooltip } from '@zorro/design-system/v2/Tooltip';
import { Children, ReactNode, isValidElement } from 'react';

import {
  CopyableTooltipContent,
  CopyableTooltipCopy,
  CopyableTooltipItem,
  CopyableTooltipLabel,
  CopyableTooltipTarget,
  CopyableTooltipValue,
} from './CopyableTooltipContent';

type Props = {
  children: ReactNode;
  isDisabled?: boolean;
};

export const CopyableTooltip = ({ children, isDisabled = false }: Props) => {
  const childArray = Children.toArray(children);
  const target = childArray.find(
    (child) => isValidElement(child) && child.type === CopyableTooltipTarget
  );
  const content = childArray.find(
    (child) => isValidElement(child) && child.type === CopyableTooltipContent
  );

  return (
    <InteractiveTooltip
      position="top-start"
      isDisabled={isDisabled}
      content={content}
    >
      {target}
    </InteractiveTooltip>
  );
};

CopyableTooltip.Target = CopyableTooltipTarget;
CopyableTooltip.Content = CopyableTooltipContent;
CopyableTooltip.Item = CopyableTooltipItem;
CopyableTooltip.Label = CopyableTooltipLabel;
CopyableTooltip.Value = CopyableTooltipValue;
CopyableTooltip.Copy = CopyableTooltipCopy;
